module.exports = __webpack_public_path__ + "static/media/dashboard.5b564e5c.svg";